import { flushTableWithService } from 'serviceWorker/db/flush';
import type { HustroDbEntityTablesUnion } from 'serviceWorker/db';
import { swSignals } from 'serviceWorker/events/swSignals';
import { swLog } from 'serviceWorker/helpers/makeSwLogger';
import { INVALID_SYNCKEY } from 'shared/contants';
import { LogLevel } from 'shared/types/logger';
import { InvalidSyncKeyError } from './invalidSyncKeyError';

/**
 * The answer to a sync of `table`, passed on as it is unless the sync key was
 * refused (`INVALID_SYNCKEY`). Then the table is cleared with its state, the
 * services are told (`syncKeyInvalidated`), it is logged as info and the sync
 * rejects with `InvalidSyncKeyError`. One place for every fetcher of changes.
 */
export async function rejectInvalidSyncKey(response: Response, table: HustroDbEntityTablesUnion): Promise<Response> {
  if (response.status !== INVALID_SYNCKEY) {
    return response;
  }
  await flushTableWithService(table);
  swSignals.syncKeyInvalidated.emit();
  const error = new InvalidSyncKeyError(table);
  swLog(error.message, LogLevel.INFO, null, { entityName: table });
  throw error;
}
